import { t } from "@lingui/macro";
import { useDialog } from "@/client/stores/dialog";
import { FilterResumeType } from "@reactive-resume/dto";
import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Form,
  FormField,
  FormItem,
  FormLabel,
  Input,
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  FormControl,
  SelectValue,
  SelectTrigger,
  ScrollArea,
} from "@reactive-resume/ui";
import { useRef } from "react";
import { useForm } from "react-hook-form";
import { SelectFormField } from "../_components/select-form-fields";
import { useFilterResumeStore } from "@/client/stores/filter-resume";
import { usefilterUser } from "@/client/services/user/filter-user";

type StringFilterCondition = "startsWith" | "contains" | "equals" | "endsWith";
type DateFilterCondition = "gt" | "gte" | "equals" | "lt" | "lte";
export type ResumeFormType = {
  title?: {
    condition: StringFilterCondition;
    value: string;
  };
  userId?: {
    condition: StringFilterCondition;
    value: string;
  };
  createdAt?: {
    condition: DateFilterCondition;
    value: string;
  };
  updatedAt?: {
    condition: DateFilterCondition;
    value: string;
  };
};

const ObjectConversionToFilterType = (object: ResumeFormType) => {
  const filter: FilterResumeType = {};
  Object.entries(object).forEach(([key, field]) => {
    if (!field || !field.value) return;

    filter[key as keyof ResumeFormType] = {
      [field.condition]: field.value,
    };
  });
  return filter;
};

export const FilterResumeDialog = () => {
  type FormValue = ResumeFormType;

  const formRef = useRef<HTMLFormElement>(null);
  const { replaceFilterResume } = useFilterResumeStore();
  const { filterUsers } = usefilterUser(false);
  //let sortUsers = filterUsers?.data.sort((a, b) => a.name.localeCompare(b.name));
  let { open, isOpen, mode, close } = useDialog("filter-resume");
  const form = useForm<FormValue>({
    defaultValues: {
      title: {
        condition: "contains",
        value: "",
      },
      userId: {
        condition: "equals",
        value: "",
      },
      updatedAt: {
        condition: "equals",
        value: "",
      },
      createdAt: {
        condition: "equals",
        value: "",
      },
    },
  });
  const OnSubmit = (data: FormValue) => {
    try {
      data.userId!.condition = "equals";
      const filter = ObjectConversionToFilterType(data);
      replaceFilterResume(filter);
      form.reset();
      close();
    } catch {
      form.reset();
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={close}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t`Filtrer les CV`}</DialogTitle>
        </DialogHeader>
        <Form {...form}>
          <form
            ref={formRef}
            onSubmit={form.handleSubmit(OnSubmit)}
            className="flex flex-col gap-y-4"
          >
            <div className="flex flex-row gap-2">
              <div className="flex w-1/2 flex-col gap-2">
                <SelectFormField
                  label="Titre"
                  form={form}
                  condition="String"
                  nameField="title.condition"
                />
                <Input {...form.register("title.value")} />
              </div>
              <div className="flex w-1/2 flex-col gap-2">
                <SelectFormField
                  label="Utilisateur"
                  form={form}
                  condition="String"
                  nameField="userId.condition"
                  disabled={true}
                />
                <FormField
                  name="userId.value"
                  render={({ field }) => (
                    <FormItem className="w-full">
                      <Select
                        value={field.value}
                        onValueChange={(value) => {
                          field.onChange(value);
                        }}
                      >
                        <FormControl>
                          <SelectTrigger className="w-full">
                            <SelectValue placeholder="Sélectionner un client" />
                          </SelectTrigger>
                        </FormControl>
                        <SelectContent>
                          <ScrollArea orientation="vertical" className="h-[300px]">
                            {/* <SelectGroup> */}
                            {/* <SelectLabel>Selectionner un client</SelectLabel> */}
                            {filterUsers?.data
                              .slice()
                              .sort((a, b) => a.name.localeCompare(b.name))
                              .map((item) => {
                                return (
                                  <>
                                    <SelectItem value={item.id}>
                                      {" "}
                                      <span className="font-bold">{item.name}</span> ||{" "}
                                      <span className="text-moncvpro-secondary text-lg font-bold">
                                        {" "}
                                        {item.email}
                                      </span>
                                    </SelectItem>
                                  </>
                                );
                              })}
                            {/* </SelectGroup> */}
                          </ScrollArea>
                        </SelectContent>
                      </Select>
                    </FormItem>
                  )}
                />
              </div>
            </div>

            <div className="flex flex-row gap-2">
              <div className="flex w-1/2 flex-col gap-2">
                <SelectFormField
                  label="Crée le"
                  form={form}
                  condition="Date"
                  nameField="createdAt.condition"
                />
                <Input {...form.register("createdAt.value")} type="date" />
              </div>
              <div className="flex w-1/2 flex-col gap-2">
                <SelectFormField
                  label="Dernière Activité le"
                  form={form}
                  condition="Date"
                  nameField="updatedAt.condition"
                />
                <Input {...form.register("updatedAt.value")} type="date" />
              </div>
            </div>

            <div className="flex justify-center gap-x-3">
              <Button type="submit" className="bg-moncvpro-secondary">
                {"Valider"}
              </Button>
            </div>
          </form>
        </Form>
      </DialogContent>
      <DialogFooter></DialogFooter>
    </Dialog>
  );
};
